import { Col, Row } from "reactstrap";
import { TourAddressData, TourInfoData } from "../../../../data/bonusUi/Tour";
import { Link } from "react-router-dom";
import { Href, WebDesigner, WilliamJennings } from "../../../../constants";

const InfoSection = () => {
  return (
    <Row className="g-3">
      <Col sm="6" xl="4">
        <Row className="g-3">
          {TourInfoData.map(({ className, iconClass, text, spanText }, index) => (
            <Col md="6" key={index}>
              <div className={`text-start tour-email ${className}`}>
                <h6 className="tour-mb-space">
                  <i className={`fa fa-${iconClass} me-2`}></i>
                  {text}
                </h6>
                <span>{spanText}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Col>
      <Col sm="12" xl="4" className="order-sm-0 order-xl-1">
        <div className="user-designation tour-email">
          <div className="title">
            <Link target="_blank" to={Href}>
              {WilliamJennings}
            </Link>
          </div>
          <div className="desc mt-2">{WebDesigner}</div>
        </div>
      </Col>
      <Col sm="6" xl="4">
        <Row className="g-3">
          {TourAddressData.map(({ colClass, iconClass, className, text, spanText }, index) => (
            <Col md="6" className={colClass} key={index}>
              <div className={`text-start ${className} tour-email`}>
                <h6 className="tour-mb-space">
                  <i className={`fa fa-${iconClass} me-2`}></i>
                  {text}
                </h6>
                <span>{spanText}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};
export default InfoSection;
